


















































import Component, { mixins } from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import Doughnut from "@/charts/Doughnut.vue";
import jsonURLTotal from "@/shared/UrlsTotal";
import GraphData, {
  DataSet,
  ChartOptions,
  MyOptions,
} from "@/charts/graphData";
import moment from "moment/moment";
import NumberTmpl from "@/ui-component/number.vue";
import ChartsCommon from "./chartsMixin";

@Component({
  components: {
    Doughnut,
  },
})
export default class TauxCatVendeur extends mixins(ChartsCommon) {
  public dataGetted = false;
  public labels: Array<string> = [];
  public data: Array<number> = [];
  public options: ChartOptions = new ChartOptions();
  public config: any;
  public titre = "";

  @Prop() public myOptions!: MyOptions;

  @Watch("myOptions", { immediate: false, deep: true })
  public onPeriodeChanged(value: any, oldValue: any) {
    this.init();
  }

  public mounted() {
    // moment.locale("fr");
  }

  public init() {
    console.log("tauxcat vendeur");
    this.dataGetted = false;
    this.config = {
      site: this.myOptions.site[0],
      date: moment(this.myOptions.date).format("YYYY-MM-DD"),
      colors: this.colors,
    };
    // this.updateWs();
    this.orderConfig();
    this.$store
      .dispatch("home/getServiceHomeData", {
        config: this.config,
        WS: "getTauxCATParVendeur",
      })
      .then((data: any) => {
        // console.log(data);
        this.orderData(data);
        this.setOptions();
      });
  }
  /**
   * mise a jour du titre du graphique (date)
   */
  private orderConfig(): any {
    let graphTitle = "";
    graphTitle = this.dateOrdering(this.myOptions.periode, this.myOptions.date);
    this.titre = graphTitle;
  }
  /**
   * mise a jour du web service en fonction de la periode
   */
  private updateWs() {
    switch (this.myOptions.periode) {
      case "J":
        this.config.WS = jsonURLTotal.PRESTA_MOYPAI_JOUR;
        break;
      case "MOIS":
        this.config.WS = jsonURLTotal.PRESTA_MOYPAI_MOIS;
        break;
      case "ANNEE":
        this.config.WS = jsonURLTotal.PRESTA_MOYPAI_ANNEE;
        break;
    }
  }

  /**
   * methode permettant de mettre à jour les options du graphique
   */
  private setOptions() {
    this.options.setTitleTxt("Vente");
    this.options.makeMeADoughnut();
    // console.log(this.optionsPresta);
  }
  /**
   * mise en forme des données
   */
  private orderData(lignes: any) {
    // 1: vente, 0 : presta
    let labels = [];
    this.labels = [];
    this.data = [];

    labels = Object.keys(lignes);
    labels.forEach((label: string) => {
      if (label !== "") {
        this.labels.push(label);
        this.data.push(lignes[label][1]);
      }
    });
    this.dataGetted = true;
  }
}
